import React, { useEffect } from 'react'
import Banner from '../Components/Banner';
import BannerImage from "../Images/service-banner.jpg";
import ContactSection from '../Components/ContactSection';
import Ser1 from "../Images/corporateEvents/1.jpg";
import Ser2 from "../Images/corporateEvents/2.jpg";
import Ser3 from "../Images/corporateEvents/3.jpg";
import Ser4 from "../Images/corporateEvents/4.jpg";
import Ser5 from "../Images/corporateEvents/5.jpg";
import Ser6 from "../Images/corporateEvents/6.jpg";
import Ser7 from "../Images/corporateEvents/7.jpg";
import Ser8 from "../Images/corporateEvents/8.jpg";
import { Col, Container, Row, Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const CorporateEvents = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0,0);
    }, [location.key])
  const bannerTitle = (
    <>
      Corporate Events
    </>
  );
  const bannerContent = "";
  const bannerConclude = "";
  const serviceData = [
    {
      id: 1,
      title: 'Annual Meets',
      image: Ser1,
      description: 'Annual Meets'
    },
    {
      id: 2,
      title: 'Cultural Events',
      image: Ser2,
      description: 'Cultural Events'
    },
    {
      id: 3,
      title: 'Farewell Parties',
      image: Ser3,
      description: 'Farewell Parties'
    },
    {
      id: 4,
      title: 'Get Togethers',
      image: Ser4,
      description: 'Get Togethers'
    },
    {
      id: 5,
      title: 'Holiday Parties',
      image: Ser5,
      description: 'Holiday Parties'
    },
    {
      id: 6,
      title: 'Milestone Celebrations',
      image: Ser6,
      description: 'Milestone Celebrations'
    },
    {
      id: 7,
      title: 'Retirement Parties',
      image: Ser7,
      description: 'Retirement Parties'
    },
    {
      id: 8,
      title: 'Anniversary celebrations',
      image: Ser8,
      description: 'Anniversary celebrations'
    }
  ];
  
  return (
    <div className='home-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />
      <section className="services-section py-5">
          <Container>
            
            <h2 className="text-center mb-5">Elegant Dining Experiences in</h2>
            
            <Row className="g-4">
              {serviceData.map((service, index) => (
                <Col key={service.id} xs={12} sm={6} md={4} lg={3}>
                  <Card className={`service-card h-100 ${((index + 1) % 2 === 0) ? 'mt-5' : ''}`}>
                    <div className="card-img-wrapper">
                      <Card.Img variant="top" src={service.image} alt={service.title} />
                    </div>
                    <Card.Body>
                      <Card.Title>
                        <div className="stretched-link text-decoration-none text-dark">
                          {service.title}
                        </div>
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <ContactSection />
    </div>
  )
}

export default CorporateEvents